// Caution: this download method does not work on safari mobile

export default function downloadDataUrl(dataUrl: string, fileName: string) {
    const element = document.createElement('a')
    element.setAttribute('href', dataUrl)
    element.setAttribute('download', fileName)
    element.style.display = 'none'

    document.body.appendChild(element)

    element.click()

    document.body.removeChild(element)
}
